/** @file The layers a plan rigs (its new regions' images), for the review's per-layer pivot hints. */
import type { AutorigPlan } from '@pose2d/autorig/types';
import type { Doc, ImageDoc } from '@pose2d/format/types';

/** One part: the image name (the pivot key) and its size in pixels (the pivot's range). */
export interface PlanPart {
  name: string;
  w: number;
  h: number;
}

/** In plan order, each image once; a region naming an unknown image is skipped (the server reports it). */
export function planParts(doc: Doc, plan: AutorigPlan): PlanPart[] {
  const images = new Map<string, ImageDoc>();
  for (const [id, image] of Object.entries(doc.images)) images.set(id, image).set(image.name, image);
  const parts = new Map<string, PlanPart>();
  for (const call of plan.commands) {
    const ref = call.name === 'attachment.createRegion' ? (call.input as { image?: unknown }).image : undefined;
    const image = typeof ref === 'string' ? images.get(ref) : undefined;
    if (image !== undefined && !parts.has(image.name)) parts.set(image.name, { name: image.name, w: image.w, h: image.h });
  }
  return [...parts.values()];
}
